import React, { useEffect } from 'react'

import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import PriceComparisonDrawer from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Drawer"
import PriceComparisonTable from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Table"
import { alertsSection, isPriceComparisonTabLoading } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import { BACKEND_APIS } from "@constants"
import { isTourDemoActive } from "@signals/app"


export default function PriceComparisonBlock() {
	const {
		isAlertSubmitting,
		onGenerateAlert,
		onSubmitAlert,
		onEditAlert,
		tableData,
		getTableData,
		isTableLoading,
		onDeleteAlert,
		filterConditions
	} = useAlertsTableData(`${BACKEND_APIS.CONDITIONS}/price-comparison`)

	useEffect(() => {
		isPriceComparisonTabLoading.value = true
		getTableData()
			.then(() => isPriceComparisonTabLoading.value = false)
			.catch(() => isPriceComparisonTabLoading.value = false)
	}, [])

	if (alertsSection.value !== ALERTS.PRICE_COMPARISON) return <></>

	return <>
		{!(isTourDemoActive.value && !tableData?.length) && <PriceComparisonTable
			data={tableData}
			onDeleteAlert={onDeleteAlert}
			isLoading={isTableLoading}
			onGenerateAlert={onGenerateAlert}
			onEditAlert={onEditAlert}
			filterConditions={filterConditions}
		/>}
		<PriceComparisonDrawer onSubmitAlert={onSubmitAlert} isLoading={isAlertSubmitting}/>
	</>

}